import { DATE_FORMAT } from '@/constants/common.constant'
import { AxiomReportType } from '@/enums/axiom-report.enum'
import { IReportDTO } from '@/interfaces/report.interface'
import { Circle, Close, MoreVert } from '@mui/icons-material'
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'

const ReportParametersPopover: React.FC<{ selectedReport: IReportDTO }> = ({
  selectedReport,
}) => {
  const [reportParameters, setReportParameters] = useState<string[]>([])
  // Page Info Popover
  const [pageInfoPopoverAnchorEl, setPageInfoPopoverAnchorEl] =
    useState<HTMLButtonElement | null>(null)
  const handlePageInfoPopoverClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setPageInfoPopoverAnchorEl(event.currentTarget)
  }
  const handlePageInfoPopoverClose = () => {
    setPageInfoPopoverAnchorEl(null)
  }
  const displayPageInfoPopover = Boolean(pageInfoPopoverAnchorEl)
  const pageInfoPopoverId = displayPageInfoPopover
    ? 'page-info-popover'
    : undefined

  useEffect(() => {
    const portfolio = `Portfolio: ${selectedReport.portfolioName}`
    const benchmark = `Benchmark: ${selectedReport.benchmarkName}`
    const template = `Template : ${selectedReport.templateName}`
    const dateCreated = `Date Created : ${dayjs(selectedReport.reportEndTime).format(DATE_FORMAT.TABLE_CHART)}`
    const reportId = `Report Id : ${selectedReport.reportId}`
    let date
    let matrix = ''
    if (selectedReport.reportType === AxiomReportType.GFR) {
      date = `As of date : ${dayjs(selectedReport.beginDate)?.format(DATE_FORMAT.TABLE_CHART)}`
      matrix = `Matrix : ${selectedReport.matrixName ? selectedReport.matrixName : ''}`
    } else if (selectedReport.reportType === AxiomReportType.SCEN) {
      date = `As of date : ${dayjs(selectedReport.beginDate)?.format(DATE_FORMAT.TABLE_CHART)}`
    } else {
      date = `Date Range : ${dayjs(selectedReport.beginDate)?.format(DATE_FORMAT.TABLE_CHART)} - ${dayjs(selectedReport.endDate)?.format(DATE_FORMAT.TABLE_CHART)}`
    }
    const reportParams = [
      portfolio,
      benchmark,
      date,
      template,
      dateCreated,
      reportId,
    ]
    if (selectedReport.reportType === AxiomReportType.GFR) {
      reportParams.push(matrix)
    }
    setReportParameters(reportParams)
  }, [selectedReport])
  return (
    <>
      <IconButton
        aria-describedby={pageInfoPopoverId}
        onClick={handlePageInfoPopoverClick}
        data-cy='report-parameters-toggle-button'
      >
        <MoreVert fontSize='inherit' />
      </IconButton>
      <Popover
        id={pageInfoPopoverId}
        open={displayPageInfoPopover}
        anchorEl={pageInfoPopoverAnchorEl}
        onClose={handlePageInfoPopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Card data-cy='report-parameters-card'>
          <CardHeader
            title={<Typography variant='h3'>Report Parameters</Typography>}
            action={
              <IconButton onClick={handlePageInfoPopoverClose}>
                <Close />
              </IconButton>
            }
          />
          <Divider orientation='horizontal' />
          <CardContent sx={{ minWidth: '20rem' }}>
            <List
              component='ul'
              dense
              disablePadding
              sx={{ listStyle: 'initial' }}
            >
              {reportParameters?.map((item: string) => (
                <ListItem key={item} dense sx={{ px: 0 }}>
                  <ListItemIcon sx={{ fontSize: '0.5rem' }}>
                    <Circle fontSize='inherit' />
                  </ListItemIcon>
                  <ListItemText>{item}</ListItemText>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Popover>
    </>
  )
}

export default ReportParametersPopover
